import { z } from 'zod'
import { newPasswordValidationSchema } from '~/@pages_account-settings/password/change-password-form/changePasswordSchema'

export const registerSchema = z.object({
  email: z.email('Email je v neplatnom tvare').min(1, 'Email je povinný'),
  password: newPasswordValidationSchema('Zadajte heslo'),
  lang: z.string(),
  gdpr: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že súhlasíte so spracovaním osobných údajov',
  }),
  marketing: z.boolean(),
  bonusCode: z.string().optional(),
  tokenAffilRecommender: z.string().optional(),
})

export type RegisterSchema = z.infer<typeof registerSchema>
